import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { knowledgeService } from '../../../services/KnowledgeService';
import { knowledgeQueryKeys } from '../knowledgeQueryKeys';

export function useKnowledgeDocumentDownloadQuery(
  databaseId: string | undefined,
  documentId: string | undefined,
  options?: { enabled?: boolean },
) {
  const { user } = useAuth();
  const resolvedDatabaseId = databaseId?.trim() ?? '';
  const resolvedDocumentId = documentId?.trim() ?? '';
  const isEnabled =
    (options?.enabled ?? true) &&
    Boolean(user) &&
    resolvedDatabaseId.length > 0 &&
    resolvedDocumentId.length > 0;

  return useQuery({
    queryKey: knowledgeQueryKeys.documentDownload(
      resolvedDatabaseId,
      resolvedDocumentId,
    ),
    enabled: isEnabled,
    staleTime: Infinity,
    gcTime: Infinity,
    queryFn: () =>
      knowledgeService.downloadDocument(resolvedDatabaseId, resolvedDocumentId),
  });
}
